import React, { useContext, useState, useEffect } from 'react';
import DataContext from '../../Component/context';
import Alert from 'react-bootstrap/Alert';
import { validEmail } from '../../Component/Element/Regex';
import { ApiService } from '../../Component/services/apiServices';
import OTPInput from 'react-otp-input';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
function Login() {
    const navigate = useNavigate()
    const contextValues = useContext(DataContext)
    const [step, setStep] = useState(1);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [loginData, setLoginData] = useState({
        user_email: "",
        user_password: ""
    })

    const [userRegDetails, setUserRegDetails] = useState({
        user_name: '',
        user_email: "",
        user_mobile: "",
        user_pass: '',
        country_code: 61,
    });
    const [forgetPassword, setforgetPassword] = useState({
        userforget_email: "",
    });

    const [resetPassword, setresetPassword] = useState({
        password: "",
        confirm_pass: ''
    });

    const [resendTimer, setResendTimer] = useState(30);
    const [otp, setOtp] = useState('');

    useEffect(() => {
        if (localStorage.getItem('USER_TOKEN')) {
            navigate('/home', { replace: true });
        }
        if (Capacitor.getPlatform() !== 'web') {
            StatusBar.setOverlaysWebView({ overlay: false });
            StatusBar.setBackgroundColor({ color: '#FFFFFF' });
            StatusBar.setStyle({ style: Style.Lignt });
          }
    }, []);

    useEffect(() => {
        const timerId = setInterval(() => {
            if (resendTimer > 0) {
                setResendTimer(prev => prev - 1);
            }
        }, 1000);
        return () => {
            clearInterval(timerId);
        };
    }, [resendTimer]);

    const handleLoginChange = (e) => {
        setErrorMessage('')
        setSuccessMessage('')
        const { name, value } = e.target;
        setLoginData(prevDetails => ({
            ...prevDetails,
            [name]: value
        }));
        if (value !== '') {
            e.target.style.border = '';
        }
    };

    const loginProcess = () => {
        let counter = 0;
        const loginElements = document.getElementsByClassName("loginRequired");
        for (let i = 0; i < loginElements.length; i++) {
            if (loginElements[i].value === '') {
                loginElements[i].style.border = '1px solid red';
                counter++;
            } else {
                loginElements[i].style.border = '';
            }
        }
        const dataString = {
            user_email: loginData.user_email,
            user_password: loginData.user_password,
        }
        if (counter === 0) {
            if (!validEmail.test(loginData.user_email)) {
                setErrorMessage('Invalid Email Format')
                return false;
            }
            setButtonLoader(true)
            ApiService.loginProccessPostData("user-login", dataString).then((res) => {
                if (res.status === "success") {
                    localStorage.setItem("USER_TOKEN", res.data.user_token)
                    contextValues.setUserToken(res.data.user_token)
                    setSuccessMessage(res.message);
                    setButtonLoader(false)
                    setTimeout(() => {
                        navigate('/home', { replace: true });
                    }, 500);
                } else {
                    setButtonLoader(false)
                    setErrorMessage(res.message);
                }
            }).catch(() => {
                setButtonLoader(false)
            })
        }
    }

    const onChangeStep = (step) => {
        setStep(step)
        clearErrorStyles()
        setErrorMessage('')
        setResendTimer(30)
        setforgetPassword({ userforget_email: '' })
        setresetPassword({
            password: "",
            confirm_pass: ''
        })
        setOtp('')
        setLoginData({
            user_email: "",
            user_pass: "",
        })
        setUserRegDetails({
            user_name: '',
            user_email: "",
            user_mobile: "",
            user_pass: '',
            country_code: 61,
        })
    }

    const clearErrorStyles = () => {
        const allInputs = document.querySelectorAll('input');
        allInputs.forEach(input => {
            input.style.border = '';
        });
    }

    const onTodoRegChange = (e) => {
        setErrorMessage('')
        const { name, value } = e.target;
        setUserRegDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        if (value !== '') {
            e.target.style.border = '';
        }
    }

    const registerProcess = (e) => {
        let counter = 0;
        const myElements = document.getElementsByClassName("userRegisterRequired");
        for (let i = 0; i < myElements.length; i++) {
            if (myElements[i].value === '') {
                myElements[i].style.border = '1px solid red';
                counter++;
            } else {
                myElements[i].style.border = '';
            }
        }
        if (counter === 0) {
            if (!validEmail.test(userRegDetails.user_email)) {
                setErrorMessage('Please enter valid email address')
                setTimeout(() => {
                    setErrorMessage('')
                }, 3000);
                return false;
            }
            const dataString = {
                user_name: userRegDetails.user_name,
                user_mobile: userRegDetails.user_mobile,
                user_email: userRegDetails.user_email,
                user_password: userRegDetails.user_pass,
            };
            setButtonLoader(true)
            ApiService.loginProccessPostData("user-registration-process", dataString).then((res) => {
                if (res.status === "success" || res.status === 'incomplete') {
                    setResendTimer(30)
                    localStorage.setItem("TEMP_USER_TOKEN", res.user_token)
                    setButtonLoader(false)
                    setStep(6)
                    if (res.status === 'incomplete') {
                        resendRegisOTP()
                    }
                } else if (res.status === 'error' && res.message === 'Session expired') {
                    setErrorMessage(res.message);
                    setButtonLoader(false)
                    setTimeout(() => {
                        localStorage.removeItem('TEMP_USER_TOKEN')
                        navigate('/', { replace: true });
                    }, 500);
                } else if (res.status === 'error') {
                    setErrorMessage(res.message);
                    setButtonLoader(false)
                }
            }).catch((error) => {
                setErrorMessage('')
                setButtonLoader(false)
            });
        }
    }

    const userForgetProcess = () => {
        setErrorMessage("");
        let counter = 0;
        const forgotElements = document.getElementsByClassName("userForgotRequired");
        for (let i = 0; i < forgotElements.length; i++) {
            if (forgotElements[i].value === '') {
                forgotElements[i].style.border = '1px solid red';
                counter++;
            } else {
                forgotElements[i].style.border = '';
            }
        }
        if (counter === 0) {
            if (!validEmail.test(forgetPassword.userforget_email)) {
                setErrorMessage("Invalid Email Format");
                return false;
            }
            setButtonLoader(true)
            const dataString = {
                "user_email": forgetPassword.userforget_email,
            };
            ApiService.loginProccessPostData('forgot-password', dataString).then((res) => {
                if (res?.status === 'success') {
                    setResendTimer(30)
                    setButtonLoader(false)
                    setTimeout(() => {
                        setStep(4)
                    }, 500);
                } else {
                    setButtonLoader(false)
                    setTimeout(() => {
                        setErrorMessage(res.message);
                    }, 500);
                }
            }).catch((error) => {
                setButtonLoader(false)
            })
        }
    }

    const onChangeforgetOtp = (otp) => {
        setErrorMessage("")
        setSuccessMessage('')
        setOtp(otp);
        if (otp.length === 5) {
            onOtpverify(otp)
        }
    };

    const onChangeregisterOtp = (otp) => {
        setErrorMessage("")
        setSuccessMessage('')
        setOtp(otp);
        if (otp.length === 5) {
            onRegisOtpverify(otp)
        }
    };

    const onOtpverify = (otp) => {
        if (otp.length === 0) {
            setErrorMessage('Please Enter  OTP');
            return false;
        }
        else if (otp.length !== 5) {
            setErrorMessage('Please Enter Correct OTP');
            return false;
        }
        setButtonLoader(true)

        const dataString = {
            user_email: forgetPassword.userforget_email,
            user_otp: otp,
        };
        ApiService.loginProccessPostData('check-reset-password-otp', dataString).then((res) => {
            if (res?.status === 'success') {
                setButtonLoader(false)
                setOtp('')
                setStep(5)
            } else {
                setButtonLoader(false)
                setTimeout(() => {
                    setErrorMessage(res.message);
                }, 500);
            }
        }).catch((error) => {
            setButtonLoader(false)
        })

    }

    const resendOTP = () => {
        setErrorMessage("");
        setResendTimer(30);
        setOtp("");
        setButtonLoader(true)
        const dataString = {
            "user_email": forgetPassword.userforget_email,
        };
        ApiService.loginProccessPostData('forgot-password', dataString).then((res) => {
            if (res.status === "success") {
                setButtonLoader(false);
            } else if (res.status === 'error' && res.message === 'Session expired') {
                setErrorMessage(res.message);
                setButtonLoader(false);
                setTimeout(() => {
                    setErrorMessage('')
                    navigate('/', { replace: true });
                }, 500);
            }
            else {
                setErrorMessage(res.message);
                setTimeout(() => {
                    setButtonLoader(false);
                }, 500);
            }
        }).catch(() => {
            setButtonLoader(false);
        });
    }

    const onTodoPassChange = (e) => {
        setErrorMessage('')
        const { name, value } = e.target;
        setresetPassword((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        if (value !== '') {
            e.target.style.border = '';
        }
    }

    const onChangePassword = () => {
        let counter = 0;
        const myElements = document.getElementsByClassName("userPasschange");
        for (let i = 0; i < myElements.length; i++) {
            if (myElements[i].value === '') {
                myElements[i].style.border = '1px solid red';
                counter++;
            } else {
                myElements[i].style.border = '';
            }
        }
        if (counter === 0) {
            if (resetPassword.confirm_pass !== resetPassword.password) {
                setErrorMessage('Please enter correct confirm password that match with password')
                return false;
            }

            const dataString = {
                user_email: forgetPassword.userforget_email,
                password: resetPassword.password,
            };
            setButtonLoader(true)
            ApiService.loginProccessPostData("change-password", dataString).then((res) => {
                if (res.status === "success") {
                    setSuccessMessage(res.message)
                    setButtonLoader(false)
                    setTimeout(() => {
                        setSuccessMessage('')
                        setStep(1)
                    }, 1500);
                } else if (res.status === 'error' && res.message === 'Session expired') {
                    setErrorMessage(res.message);
                    setButtonLoader(false)
                    setTimeout(() => {
                        localStorage.removeItem("USER_TOKEN");
                        navigate('/', { replace: true });
                    }, 500);
                } else if (res.status === 'error') {
                    setErrorMessage(res.message);
                    setButtonLoader(false)
                }
            }).catch((error) => {
                setErrorMessage('')
                setButtonLoader(false)
            });
        }

    }

    const onRegisOtpverify = (otp) => {
        if (otp.length === 0) {
            setErrorMessage('Please Enter  OTP');
            return false;
        }
        else if (otp.length !== 5) {
            setErrorMessage('Please Enter Correct OTP');
            return false;
        }
        setButtonLoader(true)

        const dataString = {
            user_email: userRegDetails?.user_email,
            user_register_otp: otp,
        };
        ApiService.loginProccessPostData('otpverify', dataString).then((res) => {
            if (res?.status === 'success') {
                setSuccessMessage(res.message)
                localStorage.setItem("USER_TOKEN", res.user_token)
                setTimeout(() => {
                    setSuccessMessage('')
                    navigate('/home', { replace: true });
                }, 1500);
            } else if (res.status === 'error' && res.message === 'Session expired') {
                setErrorMessage(res.message);
                setButtonLoader(false)
                setTimeout(() => {
                    localStorage.removeItem("TEMP_USER_TOKEN");
                    navigate('/', { replace: true });
                }, 500);
            }
            else {
                setTimeout(() => {
                    setErrorMessage(res.message);
                    setButtonLoader(false)
                }, 500);
            }
        }).catch((error) => {
            setButtonLoader(false)
        })

    }

    const resendRegisOTP = () => {
        setErrorMessage("");
        setResendTimer(30);
        setOtp("");
        setButtonLoader(true)
        const dataString = {
            "user_email": userRegDetails?.user_email,
        };
        ApiService.loginProccessPostData('resendotp', dataString).then((res) => {
            if (res.status === "success") {
                setButtonLoader(false);
            } else if (res.status === 'error' && res.message === 'Session expired') {
                setErrorMessage(res.message);
                setButtonLoader(false);
                setTimeout(() => {
                    setErrorMessage('')
                    localStorage.removeItem("TEMP_USER_TOKEN");
                    navigate('/', { replace: true });
                }, 500);
            }
            else {
                setErrorMessage(res.message);
                setTimeout(() => {
                    setButtonLoader(false);
                }, 500);
            }
        }).catch(() => {
            setButtonLoader(false);
        });
    }

    return (
        <>
            {step === 1 &&
                <div className='p-25 mt-50'>
                    <div className='mb-20'>
                        <img src={contextValues?.settingData?.logo ? contextValues.settingImageBaseUrl + contextValues?.settingData?.logo : '/img/logo.png'} className='wd-75 mb-20' alt='logo' />
                        <h3 className='mb-1'>Welcome Back!</h3>
                        <p className="tx-12">Sign in to your Daadi's Kitchen account to continue.</p>
                    </div>
                    {errorMessage ? <Alert key={'danger'} className='danger' variant='danger'>{errorMessage}</Alert> : ''}
                    {successMessage ? <Alert key={'success'} className='success' variant='success'>{successMessage}</Alert> : ''}
                    <div className='form-group mb-15'>
                        <label>Email Address</label>
                        <input type='email' placeholder='Email Address' onChange={(e) => handleLoginChange(e)} name='user_email' className='loginRequired'></input>
                    </div>
                    <div className='form-group mb-15'>
                        <label>Password</label>
                        <input type='password' placeholder='Password' name='user_password' onChange={(e) => handleLoginChange(e)} className='loginRequired'></input>
                    </div>
                    <button type='button' className='btn btn-primary btn-lg btn-full mb-20' disabled={buttonLoader} onClick={() => { loginProcess() }}> {buttonLoader ? (<img src="/img/loder01.gif" width="60px" height="11px" />) : ("Sign In")}</button>
                    <div className='text-center'>
                        <p onClick={() => { onChangeStep(3) }}>Forgot Password?</p>
                        <p className='mb-0 fw600'>Don't have an account? <a href='javascript:void(0)' className='tx-primary' onClick={() => { onChangeStep(2) }}>Sign Up</a></p>
                    </div>
                </div>
            }

            {/* Register Process */}
            {step === 2 &&
                <>
                    <div className="appHeader no-shadow">
                        <div className="left" onClick={() => { onChangeStep(1) }}>
                            <button type="button" className="back-button"><i class="ri-arrow-left-line"></i></button>
                        </div>
                    </div>
                    <div id="appCapsule">
                        <div className='p-25 mt-10'>
                            <div className='mb-20'>
                                <h3 className='mb-1'>Sign Up With Daadi's Kitchen</h3>
                                <p className="tx-12">Sign up for a better experience, order tracking, and updates.</p>
                            </div>
                            {errorMessage ? <Alert key={'danger'} className='danger' variant='danger'>{errorMessage}</Alert> : ''}
                            {successMessage ? <Alert key={'success'} className='success' variant='success'>{successMessage}</Alert> : ''}
                            <div className='form-group mb-15'>
                                <label>Full Name</label>
                                <input type='text' placeholder='Full Name' onChange={(e) => onTodoRegChange(e)} name='user_name' className='userRegisterRequired'></input>
                            </div>
                            <div className='form-group mb-15'>
                                <label>Email Address</label>
                                <input type='email' placeholder='Email Address' onChange={(e) => onTodoRegChange(e)} name='user_email' className='userRegisterRequired'></input>
                            </div>
                            <div className='form-group mb-0'>
                                <label>Mobile Number</label>
                            </div>

                            <div className='form-group country-input mb-15'>
                                <span className="country-code">+61</span>
                                <input type='number' placeholder='Mobile Number' onChange={(e) => onTodoRegChange(e)} name='user_mobile' className='userRegisterRequired'></input>
                            </div>
                            <div className='form-group mb-15'>
                                <label>Password</label>
                                <input type='password' placeholder='Password' name='user_pass' onChange={(e) => onTodoRegChange(e)} className='userRegisterRequired'></input>
                            </div>
                            <button type='button' className='btn btn-primary btn-lg btn-full mb-20' disabled={buttonLoader} onClick={() => { registerProcess() }}> {buttonLoader ? (<img src="/img/loder01.gif" width="60px" height="11px" />) : ("Sign Up")}</button>
                            <div className='text-center'>
                                <p className='mb-0 fw600'>Already have an account? <a href='javascript:void(0)' className='tx-primary' onClick={() => { onChangeStep(1) }}>Sign In</a></p>
                            </div>
                        </div>
                    </div>
                </>
            }

            {/* User Register Process OTP */}
            {step === 6 &&
                <>
                    <div className="appHeader no-shadow">
                        <div className="left" onClick={() => { onChangeStep(2) }}>
                            <button type="button" className="back-button"><i class="ri-arrow-left-line"></i></button>
                        </div>
                    </div>
                    <div id="appCapsule">
                    <div className='p-25 mt-50'>
                        <div className='mb-20 text-center'>
                            <img src='/img/otp_verify.jpg' className='wd-75 mb-20' alt='logo' />
                            <h3 className='mb-1'>Verify Your Email Address</h3>
                            <p className='tx-14 line18'>We have sent an OTP to your registered email address <span>{userRegDetails.user_email}</span></p>
                        </div>
                        {errorMessage ? <Alert key={'danger'} className='danger' variant='danger'>{errorMessage}</Alert> : ''}
                        {successMessage ? <Alert key={'success'} className='success' variant='success'>{successMessage}</Alert> : ''}
                        <div className='form-group otp-input mb-30'>
                            <OTPInput
                                value={otp}
                                onChange={onChangeregisterOtp}
                                numInputs={5}
                                renderInput={(props) => <input {...props} />}
                            />
                        </div>
                        {resendTimer === 0 ? (
                            <p className='tx-gray text-center mb-0 fw600'>
                                Did not receive OTP? <a href='javascript:void(0);' className='tx-primary' onClick={(e) => resendRegisOTP()}>Resend OTP</a>
                            </p>
                        ) : (
                            <p className='tx-gray text-center mb-0 fw600'>Resend OTP in {resendTimer} sec</p>
                        )}
                    </div>
                    </div>
                </>
            }

            {/* Forgot Password */}
            {step === 3 &&
                <>
                    <div className="appHeader no-shadow">
                        <div className="left" onClick={() => { onChangeStep(1) }}>
                            <button type="button" className="back-button"><i class="ri-arrow-left-line"></i></button>
                        </div>
                    </div>
                    <div id="appCapsule">
                        <div className='p-25 mt-50'>
                            <div className='mb-20'>
                                <h3 className='mb-1'>Forgot Password</h3>
                                <p className='tx-12'>Please enter the email address associated with your account to reset your password.</p>
                            </div>
                            {errorMessage ? <Alert key={'danger'} className='danger' variant='danger'>{errorMessage}</Alert> : ''}
                            {successMessage ? <Alert key={'success'} className='success' variant='success'>{successMessage}</Alert> : ''}
                            <div className='form-group mb-15'>
                                <label>Email Address</label>
                                <input type='email' placeholder='Email Address' onChange={(e) => {
                                    setforgetPassword((prevState) => ({
                                        ...prevState,
                                        'userforget_email': e.target.value,
                                    }));
                                    setErrorMessage('')
                                }} name='userforget_email' className='userForgotRequired'></input>
                            </div>
                            <button type='button' className='btn btn-primary btn-lg btn-full mb-20' disabled={buttonLoader} onClick={() => { userForgetProcess() }}> {buttonLoader ? (<img src="/img/loder01.gif" width="60px" height="11px" />) : ("CONTINUE")}</button>
                        </div>
                    </div>
                </>
            }

            {/* Forgot Password OTP */}
            {step === 4 &&
                <>
                    <div className="appHeader no-shadow">
                        <div className="left" onClick={() => { onChangeStep(3) }}>
                            <button type="button" className="back-button"><i class="ri-arrow-left-line"></i></button>
                        </div>
                    </div>
                    <div className='p-25 mt-50'>
                        <div className='mb-20 text-center'>
                            <img src='/img/otp_verify.jpg' className='wd-75 mb-20' alt='logo' />
                            <h3 className='mb-1'>Verify Your Email Address</h3>
                            <p class="tx-12 line18">We have sent an OTP to your registered email: <strong>{forgetPassword.userforget_email}</strong>.</p>
                        </div>
                        {errorMessage ? <Alert key={'danger'} className='danger' variant='danger'>{errorMessage}</Alert> : ''}
                        {successMessage ? <Alert key={'success'} className='success' variant='success'>{successMessage}</Alert> : ''}
                        <div className='form-group otp-input mb-15'>
                            <OTPInput
                                value={otp}
                                onChange={onChangeforgetOtp}
                                numInputs={5}
                                renderInput={(props) => <input {...props} />}
                            />
                        </div>
                        {resendTimer === 0 ? (
                            <p className='tx-gray text-center mb-0 fw600'>
                                Did not receive OTP? <a href='javascript:void(0);' className='tx-secondary' onClick={(e) => resendOTP()}>Resend OTP</a>
                            </p>
                        ) : (
                            <p className='tx-gray text-center mb-0 fw600'>Resend OTP in {resendTimer} sec</p>
                        )}
                    </div>
                </>
            }

            {/* Forgot Password - Change Password */}
            {step === 5 &&
                <>
                    <div className="appHeader no-shadow">
                        <div className="left" onClick={() => { onChangeStep(4) }}>
                            <button type="button" className="back-button"><i class="ri-arrow-left-line"></i></button>
                        </div>
                    </div>
                    <div className='p-25 mt-50'>
                        <div className='mb-20 text-center'>
                            <img src='/img/otp_verify.jpg' className='wd-75 mb-20' alt='logo' />
                            <h3 className='mb-1'>Change Password</h3>
                            <p className="tx-12 line18">Please enter your new password and confirm it to update your account security.</p>
                        </div>
                        {errorMessage ? <Alert key={'danger'} className='danger' variant='danger'>{errorMessage}</Alert> : ''}
                        {successMessage ? <Alert key={'success'} className='success' variant='success'>{successMessage}</Alert> : ''}
                        <div className='form-group mb-15'>
                            <label>Password</label>
                            <input type='password' placeholder='Password' name='password' onChange={(e) => onTodoPassChange(e)} className='userPasschange'></input>
                        </div>
                        <div className='form-group mb-15'>
                            <label>Confirm Password</label>
                            <input type='password' placeholder='Confirm Password' name='confirm_pass' onChange={(e) => onTodoPassChange(e)} className='userPasschange'></input>
                        </div>
                        <button type='button' className='btn btn-primary btn-lg btn-full mb-20' disabled={buttonLoader} onClick={() => { onChangePassword() }}> {buttonLoader ? (<img src="/img/loder01.gif" width="60px" height="11px" />) : ("CHANGE")}</button>
                    </div>
                </>
            }
        </>
    );
}

export default Login;